export const environment = {
  production: true,
  rootUrl: 'https://bullymake.com/wp-json',
  API_REPORTING_URL: '/api/v3/reporting',
  tokenKey:'bmdash_token',
};
